<template>
    <el-dialog title="资产移交" border :visible.sync="dialogFormVisible" width="40%">
        <div>
            <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="客资:" prop="customer" :rules="[
      { required: true, message: '请输入移交人', trigger: 'blur' }]">
                    <el-tag type="danger" class="mr10">已移交</el-tag><i class="el-icon-right"></i>&nbsp;&nbsp;
                    <el-select v-model="ruleForm.customer" filterable clearable placeholder="请选择移交人">
                        <el-option v-for="(item, index) in userList" :key="index" :label="item.realname"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="订单:" prop="order">
                    <el-row v-for="(item,index) in check_status" :key="index">
                        <el-tag type="danger" class="mr10">{{item.title}}</el-tag><i
                            class="el-icon-right"></i>&nbsp;&nbsp;
                        <el-select v-model="demOdrer[item.id]" filterable clearable placeholder="请选择移交人">
                            <el-option v-for="(item, index) in userList" :key="index" :label="item.realname"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-row>
                </el-form-item>
                <el-form-item label="订单审核:" prop="order">
                    <el-row v-for="(item,index) in check_status" :key="index">
                        <el-tag type="danger" class="mr10">{{item.title}}</el-tag><i
                            class="el-icon-right"></i>&nbsp;&nbsp;
                        <el-select v-model="demoCheckOrder[item.id]" filterable clearable placeholder="请选择移交人">
                            <el-option v-for="(item, index) in userList" :key="index" :label="item.realname"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-row>
                </el-form-item>
                <el-form-item label="结算单:" prop="order">
                    <el-row v-for="(item,index) in check_status" :key="index">
                        <el-tag type="danger" class="mr10">{{item.title}}</el-tag><i
                            class="el-icon-right"></i>&nbsp;&nbsp;
                        <el-select v-model="demoCheckSettle[item.id]" filterable clearable placeholder="请选择移交人">
                            <el-option v-for="(item, index) in userList" :key="index" :label="item.realname"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-row>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                    <el-button @click="resetForm('ruleForm')">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
    </el-dialog>
</template>

<script>
    const ruleForm = {
        // 搜索主要条件
        customer: "",
        order: [],
        check_order: [],
        check_settle: [],
        user_id: ""

    };
    export default {
        data() {
            return {
                ruleForm: Object.assign({}, ruleForm), // 搜索条件
                dialogFormVisible: false,
                detail: "",
                demOdrer: {},
                demoCheckOrder: {},
                demoCheckSettle: {},
                //资产项目
                check_status: [{
                        id: 0,
                        title: '待审核'
                    },
                    {
                        id: 1,
                        title: '审核中'
                    },
                    {
                        id: 2,
                        title: '审核通过'
                    }, {
                        id: 3,
                        title: '审核驳回'
                    },
                ],
                userList: [],
            }
        },
        created() {

        },

        methods: {

            showDrawer(row) {
                let _this = this;
                _this.dialogFormVisible = true;
                _this.detail = row;
                _this.ruleForm = Object.assign({}, ruleForm);
                _this.getSelectList = []
                _this.getPicker();
                _this.demOdrer = {};
                _this.demoCheckOrder = {},
                    _this.demoCheckSettle = {},
                    _this.ruleForm.user_id = row.id;
            },

            submitForm(formName) {
                let _this = this;
                _this.getOrder();
                _this.getCheckOrder();
                _this.getCheckSettle();
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let url = '/api/ucenter.grant/leave';
                        let query = _this.ruleForm;
                        _this.$post(url, query).then(function (res) {
                            if (res.code == 200) {
                                _this.$message.success(res.msg);
                                _this.dialogFormVisible = false;
                            } else {
                                that.$message.error(res.msg);
                            }
                        });
                        // alert('submit!');
                    } else {
                        return false;
                    }
                });
            },
            getOrder() {
                let _this = this;
                _this.ruleForm.order = []
                for (let key in _this.demOdrer) {
                    if (_this.demOdrer[key] != 0) {
                        _this.ruleForm.order.push({
                            user_id: _this.demOdrer[key], // label 字段
                            check_status: key // value字段
                        })
                    }

                }
            },
            getCheckOrder() {
                let _this = this;
                _this.ruleForm.check_order = []
                for (let key in _this.demoCheckOrder) {
                    if (_this.demoCheckOrder[key] != 0) {
                        _this.ruleForm.check_order.push({
                            user_id: _this.demoCheckOrder[key], // label 字段
                            check_status: key // value字段
                        })
                    }

                }
            },
            getCheckSettle() {
                let _this = this;
                _this.ruleForm.check_settle = []
                for (let key in _this.demoCheckSettle) {
                    if (_this.demoCheckSettle[key] != 0) {
                        _this.ruleForm.check_settle.push({
                            user_id: _this.demoCheckSettle[key], // label 字段
                            check_status: key // value字段
                        })
                    }

                }
            },
            resetForm(formName) {
                let _this = this;
                _this.demOdrer = {};
                _this.demoCheckOrder = {},
                    _this.demoCheckSettle = {},
                    this.$refs[formName].resetFields();
            },
            //添加人员
            getPicker() {
                let _this = this;
                let url = '/api/audit.dictionary/condition';
                this.$post(url).then((res) => {
                    let data = res.data;
                    _this.userList = data.userList;
                });
            },

        }
    }
</script>
<style scoped>
    .mr10 {
        margin-right: 10px;
        width: 66px;
    }
</style>